<template>
  <header class="elementor elementor-location-header shadow-md" style="background-color: var(--wp--preset--color--white);">
    <!-- Top Row: Logo and Contact Us Button -->
    <section class="elementor-section elementor-section-full_width elementor-section-stretched elementor-section-height-default py-4" >
      <div class="elementor-container mx-auto flex justify-between items-center px-4">

        <!-- Logo Section -->
        <div class="flex items-center">
          <a href="https://www.hawkrentacar.com.my">
            <img src="https://www.hawkrentacar.com.my/wp-content/uploads/car-rental.png" alt="Hawk Car Rental"  class="custom-logo"/>
          </a>
        </div>

        <!-- Contact Us Button -->
        <div class="flex items-center">
          <a
            href="https://www.hawkrentacar.com.my/contact-us/"
            class="elementor-button bg-red-600 text-white font-bold py-2 px-4 rounded hover:bg-red-700 flex items-center"
          >
            <span class="elementor-button-icon mr-2">
              <svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor">
                <path d="M497.39 361.8l-112-48a24 24 0 0 0-28 6.9l-49.6 60.6A370.66 370.66 0 0 1 130.6 204.11l60.6-49.6a23.94 23.94 0 0 0 6.9-28l-48-112A24.16 24.16 0 0 0 122.6.61l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.29 24.29 0 0 0-14.01-27.6z" />
              </svg>
            </span>
            CONTACT US
          </a>
        </div>
      </div>
    </section>

    <!-- Bottom Row: Navigation Menu with Shadow -->
    <section class="elementor-section elementor-section-full_width shadow-md" >
      <div class="elementor-container mx-auto flex justify-center py-2  test3">
        <!-- Navigation Menu -->
        <nav class="elementor-nav-menu flex space-x-4 text-gray-700 font-semibold text-base">
          <a href="https://www.hawkrentacar.com.my/about-hawk/" class="custom-menu-item elementor-item hover:text-blue-700">About Hawk</a>
          <a href="https://www.hawkrentacar.com.my/hawk-guide/" class="custom-menu-item elementor-item hover:text-blue-700">Hawk Guide</a>
          <a href="https://www.hawkrentacar.com.my/faq/" class="custom-menu-item elementor-item hover:text-blue-700">FAQ</a>
          <a href="https://www.hawkrentacar.com.my/locations/" class="custom-menu-item elementor-item hover:text-blue-700">Locations</a>
          <a href="https://www.hawkrentacar.com.my/car-leasing/" class="custom-menu-item elementor-item hover:text-blue-700">Car Leasing</a>
          <a href="https://www.hawkrentacar.com.my/privacy-policy/" class="custom-menu-item elementor-item hover:text-blue-700">Privacy Policy</a>
          <a href="https://www.hawkrentacar.com.my/terms-and-conditions/" class="custom-menu-item elementor-item hover:text-blue-700">Terms and Conditions</a>
          <a href="https://www.hawkrentacar.com.my/trucks-and-vans/" class="custom-menu-item elementor-item hover:text-blue-700">Trucks and Vans</a>
          <a href="https://www.hawkrentacar.com.my/international-booking/" class="custom-menu-item elementor-item hover:text-blue-700">International Booking</a>
        </nav>
      </div>
    </section>
  </header>
</template>

<script>
export default {
  name: "HeaderComponent",
};
</script>

<style scoped>
/* Logo Customization */
.custom-logo {
  width: 161px; /* Adjusted width for logo */
  height: auto;
}
@media (max-width: 768px) {
  .custom-logo {
    width: 80px; /* Adjusted width for mobile screens */
  }
}

/* Menu Height and Font Color */
.elementor-nav-menu {
  height: 60px; /* Custom menu height */
  line-height: 60px; /* Centers text vertically */
  padding: 0 15px; /* Optional padding for spacing */
}

.elementor-nav-menu a {
  color: #7a7a7a; /* Light gray color for the menu items */
  text-decoration: none;
  font-weight: 600;
}

.elementor-nav-menu a:hover {
  color: #0693e3; /* Adjust hover color if needed */
}

/* Section and Container Styling */

.test3 {
  background-color: #FFFFFF;  /* Padding for height control */
  box-shadow: 0px -4px 10px rgba(0, 0, 0, 0.12);
  z-index: 10;
  overflow: visible;
}


.elementor-section {
  background-color: #FFFFFF;
  padding: 0px ;
  z-index: 10;
  overflow: visible;
}

</style>
